<div class="schedule-calendar">
    <!-- <p-fullCalendar #fc [events]="events" [options]="options"></p-fullCalendar> -->
    <full-calendar #fc [events]="events" [options]="options"></full-calendar>
</div>